import React from 'react';
import { BoxIcon } from '@fiverr-private/visuals';

interface CategoryIconProps {
    webIcon?: string;
}

export const CategoryIcon = ({ webIcon }: CategoryIconProps) =>
    webIcon ? (
        <img src={webIcon} alt="" width={24} height={24} loading="lazy" />
    ) : (
        <BoxIcon size="lg" color="currentColor" />
    );
